import { Text } from '@mantine/core';
import { ContentCard } from './ContentCard';

/**
 * MED-1101 (E1 / Facilitation Foundation) — "Session Description" block shown
 * at the top of the content/reflection area on all three pre-session pages
 * (Coach prep, Peer-Leader prep, Participant pre-session).
 *
 * The value is the resolved session-number description
 * (`session_number_config.description`) — the single source of truth authored
 * in the Content Editor and returned by the agenda payload (AC7). Each page
 * sources it from its own payload server-side; this component only renders.
 *
 * - AC3  — labeled "Session Description".
 * - AC9  — hides ENTIRELY when there is no description (null/blank). This is
 *          customer/participant-facing, so an empty container would read as
 *          broken — render nothing, not an empty box.
 * - AC10 — multi-line plain text; line breaks are preserved via
 *          `white-space: pre-wrap`.
 *
 * MED-1092 — built on the shared `ContentCard` (elevated, radius 16) so it
 * matches the other prep-page cards; the label rides the card's title slot.
 */
export function SessionDescriptionBlock({
  description,
}: {
  description?: string | null;
}) {
  // AC9 — omit the block when unset OR whitespace-only.
  if (!description || description.trim() === '') return null;

  return (
    <ContentCard
      variant="elevated"
      radius={16}
      padding="lg"
      contentGap={6}
      fill={false}
      title={
        <Text size="xs" fw={700} c="dimmed" tt="uppercase">
          Session Description
        </Text>
      }
    >
      <Text size="sm" style={{ whiteSpace: 'pre-wrap' }}>
        {description}
      </Text>
    </ContentCard>
  );
}

export default SessionDescriptionBlock;
